/** Matches Tailwind `theme.fontFamily.sans` — keep global typography consistent */
export const APP_FONT_FAMILY =
  'Inter, "Noto Sans Devanagari", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
